import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import * as actions from 'redux/actions/reportActions';
import { Translate, I18n } from 'react-redux-i18n';
import { SymbolSummary, PL, Trade, SectorPlChart } from './components';
import 'assets/css/report.css';

const MONTH_OPTIONS = [
  { value: '', labelKey: 'report_all_months' },
  { value: '1', label: 'Ene' },
  { value: '2', label: 'Feb' },
  { value: '3', label: 'Mar' },
  { value: '4', label: 'Abr' },
  { value: '5', label: 'May' },
  { value: '6', label: 'Jun' },
  { value: '7', label: 'Jul' },
  { value: '8', label: 'Ago' },
  { value: '9', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dic' },
];

const Report = (props) => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState('');

  const yearOptions = useMemo(() => {
    const years = [];
    for (let y = currentYear; y >= currentYear - 6; y -= 1) {
      years.push(y);
    }
    return years;
  }, [currentYear]);

  useEffect(() => {
    const params = {
      user_id: props.user_id,
      token: props.token,
      year,
      month: month || undefined,
    };
    props.loadListRoi(params);
    props.loadListTrade(params);
  }, [props.user_id, props.token, year, month]);

  return (
    <div className="report-page">
      <header className="report-page-header">
        <div>
          <h1 className="report-page-title">
            <Translate value="report" />
          </h1>
          <p className="report-page-subtitle">
            <Translate value="report_subtitle" />
          </p>
        </div>
        <div className="report-filters">
          <div className="report-filter">
            <label htmlFor="report-year">
              <Translate value="report_year" />
            </label>
            <select
              id="report-year"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {yearOptions.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
          <div className="report-filter">
            <label htmlFor="report-month">
              <Translate value="report_month" />
            </label>
            <select
              id="report-month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              {MONTH_OPTIONS.map((m) => (
                <option key={m.value || 'all'} value={m.value}>
                  {m.labelKey ? I18n.t(m.labelKey) : m.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </header>

      <div className="report-top-row">
        <PL
          chartData={props.dataRoi}
          loading={props.loadingRoi}
          year={year}
          month={month}
        />
        <Trade
          chartData={props.dataTrade}
          loading={props.loadingTrade}
          year={year}
          month={month}
        />
      </div>

      <div className="report-bottom-row">
        <SymbolSummary year={year} month={month} />
        <SectorPlChart year={year} month={month} />
      </div>
    </div>
  );
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    dataRoi: reducer.report.dataRoi,
    dataTrade: reducer.report.dataTrade,
    loadingRoi: reducer.report.loadingRoi,
    loadingTrade: reducer.report.loadingTrade,
  };
}

const mapDispatchToProps = (dispatch) => ({
  loadListRoi: (params) => dispatch(actions.loadListLatesRoi(params)),
  loadListTrade: (params) => dispatch(actions.loadListTrade(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
